import axios from "../../../core/api/http-common";

const ON_GET_STUDENT_COURS = "/schools/streams/student/get/courses";
const ON_CHAPTERS_GET_ALL = "/schools/streams/courses/get/reading/content";
const ON_SAVE_LESSON_READING = "/schools/streams/courses/save/lesson/readed";
export function onGetStudentCourses(axiosPrivate, _data, signal) {
  const data = {
    stream_id: _data?.stream_id,
  };
  return new Promise(async (resolve, reject) => {
    await axiosPrivate.get(ON_GET_STUDENT_COURS, {
        params: data,
        signal: signal,
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
export function onGetChaptersByCourseId(axiosPrivate, _data, signal) {
  const data = {
    inscription_id: _data?.inscription_id,
    course_id: _data?.course_id,
  };
  return new Promise(async (resolve, reject) => {
    await axiosPrivate.get(ON_CHAPTERS_GET_ALL, {
        params: data,
        signal: signal,
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
export function onSaveLessonReaded(axiosPrivate, data) {
  const _data = {
    course_id: data?.course_id,
    lesson_id: data?.lesson_id,
    inscription_id: data?.inscription_id,
    dates: data?.dates,
  };
  return new Promise(async (resolve, reject) => {
    await axiosPrivate.post(ON_SAVE_LESSON_READING, _data, {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
// Lesson's Assessment
//
const ON_GET_LESSON_ASSESSMENT_AVAILABLE =
  "/schools/streams/courses/available/lesson/assessment";
const ON_CREATE_LESSON_ASSESSMENT =
  "/schools/streams/courses/create/lesson/assessment";
const ON_JOINING_ASSESSMENT =
  "/schools/streams/courses/create/lesson/assessment/joining";
const ON_PROCESS_ASSESSMENT_INVITATION =
  "/schools/streams/courses/create/lesson/assessment/process/invitation";

export function onGetLessonAssessmentAvailable(axiosPrivate, _data, signal) {
  const data = { inscription_id: _data?.inscription_id };
  return new Promise(async (resolve, reject) => {
    await axiosPrivate.get(ON_GET_LESSON_ASSESSMENT_AVAILABLE, {
        params: data,
        signal: signal,
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
export function onCreateLessonAssessment(data) {
  return new Promise(async (resolve, reject) => {
    await axios
      .post(ON_CREATE_LESSON_ASSESSMENT, data, {
        withCredentials: true,
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
export function onJoiningAssessment(axiosPrivate, data) {
  const _data = {
    inscription_id: data?.inscription_id,
    assessment_code: data?.assessment_code,
    request_dates: data?.request_dates,
  };
  return new Promise(async (resolve, reject) => {
    await axiosPrivate.post(ON_JOINING_ASSESSMENT, _data, {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
export function onProcessAssessmentInvitation(axiosPrivate, data) {
  const _data = {
    inscription_id: data?.inscription_id,
    invitation_id: data?.invitation_id,
    current_status: data?.status,
    request_dates: data?.response_dates,
  };
  return new Promise(async (resolve, reject) => {
    await axiosPrivate.patch(ON_PROCESS_ASSESSMENT_INVITATION, _data, {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
//
const ON_GET_LESSON_ASSESSMENT_CURRENT_QUESTION =
  "schools/streams/courses/lesson/assessment/get/current/question";
export function onGetLessonAssessmentCurrentQuestion(data, signal) {
  const _data = {
    assessment_id: data?.assessment_id,
    assessment_invitation_id: data?.assessment_invitation_id,
    assessment_mode: data?.assessment_mode,
  };
  return new Promise(async (resolve, reject) => {
    await axios
      .get(ON_GET_LESSON_ASSESSMENT_CURRENT_QUESTION, {
        params: _data,
        signal: signal,
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
//
// The function allow to answer the current/next question during the assessment
const ON_ANSWER_LESSON_ASSESSMENT_CURRENT_QUESTION =
  "schools/streams/courses/lesson/assessment/answering/current/question";
export function onAnsweringLessonAssessmentCurrentQuestion(data) {
  return new Promise(async (resolve, reject) => {
    await axios
      .post(ON_ANSWER_LESSON_ASSESSMENT_CURRENT_QUESTION, data, {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
